// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"7b69491a","168":"fc4c563f","216":"19257ef1","237":"e87f7d57","244":"3f750b1e","272":"fed0b765","453":"46dc3e92","520":"84fd60e6","709":"f0615b53","771":"7e636656","790":"55bc2039","801":"39f50386","824":"91ea57c4","882":"ce850890","935":"79bc3683","938":"2e690754"}[chunkId] + ".chunk.js";
};